module.exports = __webpack_public_path__ + "static/media/wallpapercelular.0f43cc21.jpg";